import useRemoveLanguage from './useRemoveLanguage'

export default useRemoveLanguage
